import {
  parseDeleteOccurrenceRequest,
  parseAdminOccurrenceDetail,
  parseApplyOccurrenceOverrideRequest,
  parseOccurrencePatchRequest,
  parsePublishScheduleMonthRequest,
  parseScheduleMonth
} from "@madamuh/domain";
import type {
  AdminOccurrenceDetailDto,
  ApplyOccurrenceOverrideRequestDto,
  DeleteOccurrenceRequestDto,
  OccurrencePatchRequestDto,
  PublishScheduleMonthRequestDto,
  ScheduleMonthDto
} from "@madamuh/domain";
import { apiDelete, apiGet, apiPatch, apiPost } from "./client";

export async function fetchAdminScheduleMonth(tenantSlug: string, yearMonth: string): Promise<ScheduleMonthDto> {
  const response = await apiGet<unknown>(`/api/v1/admin/tenants/${tenantSlug}/schedule-months/${yearMonth}`);
  return parseScheduleMonth(response);
}

export async function generateAdminScheduleMonth(tenantSlug: string, yearMonth: string): Promise<ScheduleMonthDto> {
  const response = await apiPost<Record<string, never>, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/schedule-months/${yearMonth}/generate`,
    {}
  );

  return parseScheduleMonth(response);
}

export async function validateAdminScheduleMonth(tenantSlug: string, yearMonth: string): Promise<ScheduleMonthDto> {
  const response = await apiPost<Record<string, never>, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/schedule-months/${yearMonth}/validate`,
    {}
  );

  return parseScheduleMonth(response);
}

export async function publishAdminScheduleMonth(
  tenantSlug: string,
  yearMonth: string,
  request: PublishScheduleMonthRequestDto
): Promise<ScheduleMonthDto> {
  const parsedRequest = parsePublishScheduleMonthRequest(request);
  const response = await apiPost<PublishScheduleMonthRequestDto, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/schedule-months/${yearMonth}/publish`,
    parsedRequest
  );

  return parseScheduleMonth(response);
}

export async function fetchAdminOccurrenceDetail(
  tenantSlug: string,
  occurrenceId: string
): Promise<AdminOccurrenceDetailDto> {
  const response = await apiGet<unknown>(`/api/v1/admin/tenants/${tenantSlug}/occurrences/${occurrenceId}`);
  return parseAdminOccurrenceDetail(response);
}

export async function patchAdminOccurrence(
  tenantSlug: string,
  occurrenceId: string,
  request: OccurrencePatchRequestDto
): Promise<AdminOccurrenceDetailDto> {
  const parsedRequest = parseOccurrencePatchRequest(request);
  const response = await apiPatch<OccurrencePatchRequestDto, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/occurrences/${occurrenceId}`,
    parsedRequest
  );

  return parseAdminOccurrenceDetail(response);
}

export async function applyAdminOccurrenceOverride(
  tenantSlug: string,
  occurrenceId: string,
  request: ApplyOccurrenceOverrideRequestDto
): Promise<AdminOccurrenceDetailDto> {
  const parsedRequest = parseApplyOccurrenceOverrideRequest(request);
  const response = await apiPost<ApplyOccurrenceOverrideRequestDto, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/occurrences/${occurrenceId}/overrides`,
    parsedRequest
  );

  return parseAdminOccurrenceDetail(response);
}

export async function deleteAdminOccurrence(
  tenantSlug: string,
  occurrenceId: string,
  request: DeleteOccurrenceRequestDto = {}
): Promise<ScheduleMonthDto> {
  const parsedRequest = parseDeleteOccurrenceRequest(request);
  const response = await apiDelete<DeleteOccurrenceRequestDto, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/occurrences/${occurrenceId}`,
    parsedRequest
  );

  return parseScheduleMonth(response);
}
